import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00121 14.2783C8.90179 14.3284 8.78998 14.3572 8.67104 14.3572C8.39631 14.3572 8.1572 14.2058 8.03145 13.9822L5.98105 9.48243C5.95937 9.43474 5.94574 9.38084 5.94574 9.32818C5.94574 9.12562 6.1099 8.96147 6.31246 8.96147C6.39485 8.96147 6.47073 8.98841 6.53205 9.03425L8.89497 10.7167C9.0678 10.8297 9.27408 10.896 9.49584 10.896C9.6281 10.896 9.75447 10.8713 9.87186 10.8285L20.9852 5.88214C18.9934 3.5344 15.7127 2 12 2C5.92468 2 1 6.10391 1 11.1667C1 13.9292 2.48174 16.4154 4.80067 18.096C4.98682 18.2289 5.10855 18.4469 5.10855 18.6931C5.10855 18.7746 5.0912 18.8492 5.06983 18.9267C4.88461 19.6177 4.5882 20.724 4.57426 20.7761C4.55134 20.8625 4.51511 20.9529 4.51511 21.044C4.51511 21.2462 4.67926 21.4107 4.88213 21.4107C4.96142 21.4107 5.02647 21.381 5.09368 21.3423L7.50182 19.9522C7.68301 19.8475 7.87473 19.7828 8.08596 19.7828C8.19839 19.7828 8.30711 19.8001 8.40932 19.8314C9.53301 20.1544 10.745 20.3341 12 20.3341C18.075 20.3341 23 16.2299 23 11.1667C23 9.63327 22.5459 8.18932 21.7472 6.91912L9.08143 14.2318L9.00121 14.2783Z"}}]};

const LogoWechatpayFilled = Vue.extend<IconProps>({
  name: 'LogoWechatpayFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-wechatpay-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoWechatpayFilled;
